import * as React from 'react'
function SvgLockOpen(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 8c1.2 0 2.2.4 3 1.4l1.4 1.4 3-2.6L26 6.6C24.4 5 22.2 4 20 4c-4.4 0-8 3.6-8 8v3c-2.4 2.2-4 5.4-4 9 0 6.6 5.4 12 12 12s12-5.4 12-12-5.4-12-12-12c-1.4 0-2.8.2-4 .8V12c0-2.2 1.8-4 4-4zm0 10c2.2 0 4 1.8 4 4 0 1.4-.8 2.8-2 3.4V30h-4v-4.6c-1.2-.6-2-2-2-3.4 0-2.2 1.8-4 4-4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLockOpen
